/*
 * Author: tom
 * Time: 2022/06/06
 * annotation: 插件 可以配置 全局过滤器 全局定义指令 全局mixin混入 Vue原型
 */
import indexMixin from '@/assets/mixin/index.js';
export default {
  install(Vue) {
    // 全局混入
    Vue.mixin(indexMixin)
    // 全局组件
    Vue.component(
      'pagePrivilege',
      () => import('@/components/page-privilege.vue')
    )
    Vue.component(
      'pagePrivilegeList',
      () => import('@/components/page-privilege-list.vue')
    )

    /* 时间戳转时间 */
    Date.prototype.format = function(fmt) {
      var o = {
        'Y+': this.getFullYear(),
        'M+': this.getMonth() + 1,
        'D+': this.getDate(),
        'd+': this.getDate(),
        'h+': this.getHours(),
        'm+': this.getMinutes(),
        's+': this.getSeconds(),
        'q+': Math.floor((this.getMonth() + 3) / 3),
        'S': this.getMilliseconds()
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length));
      for (var k in o) {
        if (new RegExp('(' + k + ')').test(fmt))
          fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] < 10 ? '0' + o[k] : o[k] : ('00' + o[k]).substr((
            '' + o[k]).length));
      }
      return fmt;
    };

    /* 获取时间秒 */
    Date.prototype.timestamp = function() {
      return Math.floor(this.getTime() / 1000)
    }

    /* 动态添加全局style标签class */
    Vue.prototype.appendStyle = function(styleTextNode) {
      if (styleTextNode) {
        let style = document.getElementById('appendStyle');
        if (!style) {
          style = document.createElement('style');
          style.type = "text/css";
          style.id = "appendStyle";
          style.appendChild(document.createTextNode(styleTextNode))
          document.getElementsByTagName("head")[0].appendChild(style)
        } else {
          style.appendChild(document.createTextNode(styleTextNode))
        }
      }
    }

    /* 16位颜色转rgba */
    Vue.prototype.baseToRgba = function(val, oa = 1) {
      let a, b, c;
      if ((/^rgba/g).test(val)) {
        let arr = val.split(',');
        arr[3] = `${parseFloat(arr[3]) * oa})`;
        return arr.join(',')
      }
      if ((/^rgb/g).test(val)) {
        let arr = val.split(',');
        arr[2] = `${parseFloat(arr[2])},${oa})`;
        return arr.join(',')
      }
      if ((/^#/g).test(val)) {
        if (val.length == 4) {
          a = val.slice(1, 2);
          b = val.slice(2, 3);
          c = val.slice(3, 4);
          a += a;
          b += b;
          c += c;
        } else {
          a = val.slice(1, 3);
          b = val.slice(3, 5);
          c = val.slice(5, 7);
        }
        return `rgba(${parseInt(a, 16)},${parseInt(b, 16)},${parseInt(c, 16)},${oa})`
      } else {
        return ''
      }
    }

    function numberWithCommas(number) {
      // 数字金额转 , 分割
      var parts = number.toString().split(".");
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return parts.join(".");
    }

    function moneyUpperCase() {
      let money = Number(this);
      var cnNums = new Array("零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"); //汉字的数字
      var cnIntRadice = new Array("", "拾", "佰", "仟"); //基本单位
      var cnIntUnits = new Array("", "万", "亿", "兆"); //对应整数部分扩展单位
      var cnDecUnits = new Array("角", "分", "毫", "厘"); //对应小数部分单位
      var cnInteger = "整"; //整数金额时后面跟的字符
      var cnIntLast = "元"; //整型完以后的单位
      var maxNum = 999999999999999.9999; //最大处理的数字
      var IntegerNum; //金额整数部分
      var DecimalNum; //金额小数部分
      var ChineseStr = ""; //输出的中文金额字符串
      var parts; //分离金额后用的数组，预定义
      var Symbol = ""; //正负值标记
      if (money == "" || isNaN(money)) {
        return "";
      }
      money = parseFloat(money).toFixed(2) * 1;
      if (money >= maxNum) {
        // alert('超出最大处理数字');
        return "";
      }
      if (money == 0) {
        ChineseStr = cnNums[0] + cnIntLast + cnInteger;
        return ChineseStr;
      }
      if (money < 0) {
        money = -money;
        Symbol = "负 ";
      }
      money = money.toString(); //转换为字符串
      if (money.indexOf(".") == -1) {
        IntegerNum = money;
        DecimalNum = '';
      } else {
        parts = money.split(".");
        IntegerNum = parts[0];
        DecimalNum = parts[1].substr(0, 4);
      }
      if (parseInt(IntegerNum, 10) > 0) { //获取整型部分转换
        var zeroCount = 0;
        var IntLen = IntegerNum.length;
        for (var i = 0; i < IntLen; i++) {
          var n = IntegerNum.substr(i, 1);
          var p = IntLen - i - 1;
          var q = p / 4;
          var m = p % 4;
          if (n == "0") {
            zeroCount++;
          } else {
            if (zeroCount > 0) {
              ChineseStr += cnNums[0];
            }
            zeroCount = 0; //归零
            ChineseStr += cnNums[parseInt(n)] + cnIntRadice[m];
          }
          if (m == 0 && zeroCount < 4) {
            ChineseStr += cnIntUnits[q];
          }
        }
        ChineseStr += cnIntLast;
        //整型部分处理完毕
      }
      if (DecimalNum != '') { //小数部分
        var decLen = DecimalNum.length;
        for (var i = 0; i < decLen; i++) {
          var n = DecimalNum.substr(i, 1);
          if (n != '0') {
            ChineseStr += cnNums[Number(n)] + cnDecUnits[i];
          }
        }
      }
      if (ChineseStr == '') {
        ChineseStr += cnNums[0] + cnIntLast + cnInteger;
      } else if (DecimalNum == '') {
        ChineseStr += cnInteger;
      }
      ChineseStr = Symbol + ChineseStr;
      return ChineseStr;
    }

    function moneyUpperCaseTh() {
      let amount = this;
      // 泰语 金额转大写
      // 未测试 chatGPT生成 好像有问题
      const thaiUnits = ['บาท', 'สิบ', 'ร้อย', 'พัน', 'หมื่น', 'แสน', 'ล้าน'];
      const thaiDigits = ['ศูนย์', 'หนึ่ง', 'สอง', 'สาม', 'สี่', 'ห้า', 'หก', 'เจ็ด', 'แปด', 'เก้า'];

      let thaiAmount = '';
      let numStr = String(amount * 1);
      let numArr = numStr.split('.');
      let integerPart = numArr[0];

      for (let i = integerPart.length - 1, base = 0; i >= 0; i--, base++) {
        let digitValue = Number(integerPart[i]);
        let digitStr = '';

        if (digitValue === 0) {
          continue;
        }

        if (base === 1 && digitValue === 1) {
          digitStr = thaiUnits[1];
        } else {
          digitStr = thaiDigits[digitValue];
          if (base > 0) {
            digitStr += thaiUnits[base];
          }
        }

        thaiAmount = digitStr + thaiAmount;
      }

      if (numArr.length > 1) {
        let decimalPart = numArr[1];
        let decimalStr = '';

        for (let j = 0; j < decimalPart.length; j++) {
          let digitValue = Number(decimalPart[j]);
          let digitStr = thaiDigits[digitValue];
          decimalStr += digitStr;
        }

        thaiAmount += 'จุด' + decimalStr;
      }

      return thaiAmount + 'บาทถ้วน';
    }

    String.prototype.moneyUpperCase = moneyUpperCase; //金额大写
    Number.prototype.moneyUpperCase = moneyUpperCase; //金额大写

    String.prototype.moneyUpperCaseTh = moneyUpperCaseTh; //金额大写
    Number.prototype.moneyUpperCaseTh = moneyUpperCaseTh; //金额大写

    /* toFixed精度处理 */
    Number.prototype.toFixedOld = Number.prototype.toFixed;
    Number.prototype.toFixed = function(num = 2, isFloor = false) { //解决toFixed处理精度问题
      if (isNaN(this)) {
        return this
      }
      num = +num;
      let nums = (this * Math.pow(10, num)).toFixedOld(2); // 防止出现二进制出现的小数点问题
      if (isFloor) {
        // 尾数全舍弃
        nums = Math.floor(nums)
      } else {
        // 尾数四舍五入
        nums = Math.round(nums)
      }
      return (nums / Math.pow(10, num)).toFixedOld((num <= 0 ? 0 : num))
    }
    String.prototype.toFixed = function() {
      if (isNaN(this)) {
        return this
      }
      return Number(this).toFixed(...arguments)
    }
    /* 返回状态数据 */
    Vue.prototype.statusName = (item, status_str) => {
      let tip = '';
      const $bus = Vue.prototype.$bus;
      switch (status_str) {
        case 'status':
          tip = item.status == 0 ? $bus.$ts('发结算-待支付') : item.status == 1 ? $bus.$ts('已支付-待确款') : item.status == 2 ?
            $bus.$ts('已确款-部分到款') : item.status == 3 ? $bus.$ts('已确款-全部到款') : '';
          break;
        case 'type':
          tip = item.type == 0 ? $bus.$ts('全部到款') : item.type == 1 ? $bus.$ts('部分到款') : '';
          break
        case 'create_type':
          tip = item.create_type == 0 ? $bus.$ts('线下结算') : item.create_type == 1 ? $bus.$ts('线上-对方系统账户') : '';
          break
        case 'pay_type':
          tip = item.pay_type == 0 ? $bus.$ts('其它结算') : item.pay_type == 1 ? $bus.$ts('微信结算') : item.pay_type == 2 ?
            $bus.$ts('支付宝结算') : item
            .pay_type == 3 ? $bus.$ts('现金结算') : item.pay_type == 3 ? $bus.$ts('银行卡结算') : '';
          break
      }
      return tip
    }
    // 订单状态
    Vue.prototype.orderStatus = ['新订单待生效', '已生效处理中', '配送中待收货', '已收货待结算', '发结算待到款', '已结算已到款', '已取消'];


    /* 数组映射取值 */
    Vue.prototype.arrayMapValue = (list, key) => {
      let value = [];
      list.map(item => {
        value.push(item[key])
      })
      return value
    }
    //获取缓存
    Vue.prototype.getSessionStorage = (key) => {
      let values = window.sessionStorage.getItem(key);
      if (values === undefined) {
        return "";
      }
      try {
        return JSON.parse(values, null);
      } catch (e) {
        return values;
      }
    };
    //获取缓存
    Vue.prototype.getLocalStorage = (key) => {
      let values = window.localStorage.getItem(key);
      if (values === undefined) {
        return "";
      }
      try {
        return JSON.parse(values, null);
      } catch (e) {
        return values;
      }
    };
    //设置缓存
    Vue.prototype.setLocalStorage = (key, data) => {
      if (typeof data == "string") {
        window.localStorage.setItem(key, data);
        return;
      }
      try {
        window.localStorage.setItem(key, JSON.stringify(data));
      } catch (e) {}
    }
    //清除缓存
    Vue.prototype.removeLocalStorage = (key) => {
      window.localStorage.removeItem(key)
    }

    //设置缓存
    Vue.prototype.setSessionStorage = (key, data) => {
      if (typeof data == "string") {
        window.sessionStorage.setItem(key, data);
        return;
      }
      try {
        window.sessionStorage.setItem(key, JSON.stringify(data));
      } catch (e) {}
    }

    //清除缓存
    Vue.prototype.removeStorage = (key) => {
      window.sessionStorage.removeItem(key)
    }
    //清除所有缓存
    Vue.prototype.clearStorage = () => {
      window.sessionStorage.clear()
    }

    Vue.prototype.checkType = (type, str) => {
      switch (type) {
        case 'email':
          return /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/.test(str);
        case 'phone':
          if (Vue.prototype.verifyPhone) {
            return /^1[0-9]{10}$/.test(str);
          } else {
            return true;
          }
        case 'tel':
          return /^(0\d{2,3}-\d{7,8})(-\d{1,4})?$/.test(str);
        case 'number':
          return /^[0-9]$/.test(str);
        case 'english':
          return /^[a-zA-Z]+$/.test(str);
        case 'chinese':
          return /^[\u4E00-\u9FA5]+$/.test(str);
        case 'lower':
          return /^[a-z]+$/.test(str);
        case 'upper':
          return /^[A-Z]+$/.test(str);
        case 'ID':
          return /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/
            .test(str);
        case 'int':
          str = Number(str);
          return /^[1-9][0-9]*$/.test(str);
        case 'float':
          str = Number(str);
          return /(^[1-9][0-9]*$)|(^[0-9][0-9]*\.([0-9]{0,2})$)/.test(str);
        default:
          return true;
      }
    }

    // 输入框限制数字小数点位数
    Vue.prototype.setNumber = function(val, type, num = 2) {
      //  "\^\\D*((-{1}|'')\\d*(\?:"+(num>0?"\\.\\d{0,2}":"")+")\?).*\$"
      let reg = '';
      let value = '';
      if (val) {
        val = String(val)
        if (type && val.indexOf('-') >= 0) {
          val = val.replace('-', '');
        }
        reg = new RegExp("\^\\D*(\\d*(\?:" + (num > 0 ? "\\.\\d{0,2}" : "") + ")\?).*\$", "g")
        value = val.replace(reg, '$1');
      } else {
        value = '';
      }
      return value
    }

    /* 输入数字范围处理 */
    Vue.prototype.inputRange = function(num, data, key, min = 0, max = 9999999) {
      if (num < min) {
        Vue.prototype.$nextTick(() => {
          data[key] = min;
        })
      } else if (num > max) {
        Vue.prototype.$nextTick(() => {
          data[key] = max;
        })
      }
    }

    /* 时间转换 全局过滤器注册 */
    Vue.filter('setFormat', function(num, str = 'yyyy-MM-dd hh:mm:ss', time = 0) {
      if (String(num).length == 10) {
        num = num * 1000
      }
      num += time; // 可设置前后时间
      return num ? new Date(num).format(str) : '--'
    })

    /**
     * 数量转换 万
     */
    Vue.filter('setNumberCh', function(num) {
      if (num > 10000) {
        return Vue.prototype.$bus.$ts('{num}万+', {
          num: +(num / 10000).toFixed(2)
        })
      }
      if (isNaN(num)) {
        return num
      }
      return Number(num)
    })

    /* 省略中间字符 */
    Vue.filter('setOmit', function(str, prev = 3, last = 4, num = 4) {
      if (!str) {
        return str
      }
      str = String(str);
      let strLen = str.length;
      if (strLen <= (prev + last + num)) {
        return str
      }
      let reg = new RegExp(`^(.{${prev}}).+(.{${last}})$`);
      return str.replace(reg, '$1****$2')
    })

    /**
     * oss图片处理 全局过滤器注册
     */
    function setImage(img, w = 200, type) {
      if (!img) {
        img = Vue.prototype.$bus.$store.state.system.site_logo;
      }
      if (/^(blob:|data:image)/.test(img)) {
        return img
      } else if (!/^(http)/.test(img) || /^(\/static\/)/.test(img)) {
        return Vue.prototype.url + img
      } else {
        img = img.replace('http:', 'https:')
        if (!type) {
          type = img.match(/[^\.]\w*$/)[0] || 'jpeg';
        }
        return img + `?x-oss-process=image/format,${type.toLocaleLowerCase()}${w ? ('/resize,w_' + w) : ''}`;
      }
    }

    Vue.filter('setImage', setImage)
    Vue.prototype.setImage = setImage;

    function setVideo(url, w = 100) {
      return url + `?x-oss-process=video/snapshot,t_500,m_fast${w?',w_'+w:''}`;
    }
    Vue.filter('setVideo', setVideo)
    Vue.prototype.setVideo = setVideo;

    Vue.prototype.onImageError = function(item, key) {
      let img = Vue.prototype.$bus.$store.state.system.site_logo;
      if (key) {
        item[key] = img;
      } else {
        item = img;
      }
    }

    /**
     * 数字取四舍五入 过滤器
     */
    Vue.filter('toFixed', function(num, float = 2) {
      if (!isNaN(num)) {
        return Number(num).toFixed(float)
      }
      return num
    })

    Vue.prototype.copyData = function(obj) {
      return JSON.parse(JSON.stringify(obj))
    }

    Vue.prototype.navTo = function(path, query = {}) {
      if (path) {
        this.$router.push({
          path,
          query
        })
      }
    }
    Vue.prototype.navToName = function(name, params = {}) {
      if (name) {
        this.$router.push({
          name,
          params
        })
      }
    }
    Vue.prototype.navBack = function() {
      let that = this;
      let $bus = Vue.prototype.$bus;
      if (!that) {
        that = $bus.$route.matched[1].instances.default;
      }
      if (!that.isChangeData) {
        that.$store.dispatch('tagsView/delView', that.$route)
        that.$router.go(-1)
      } else {
        that.$confirm($bus.$ts('数据未保存，确认离开该页面?'), $bus.$ts('提示'), {
          type: 'warning'
        }).then(() => {
          that.isChangeData = false;
          that.$store.dispatch('tagsView/delView', that.$route)
          that.$router.go(-1)
        }).catch(() => {})
      }
    }

    /**
     * 下拉选择值 对应进入 warehouse-change页面 type值  1采购入库 2销售退货入库 3采购退货
     */

    Vue.prototype.billType = {
      1: 1,
      5: 1,
      6: 1,
      7: 1,
      4: 2,
      2: 3,
      8: 3,
      9: 3,
      10: 3,
      11: 3,
      18: 4,
    }

    /**
     * 时间范围处理
     * @param {array} range [开始时间，结束时间]
     * @param {number} day 范围天数
     * @param {string} format 范围时间格式
     */
    Vue.prototype.rangeDay = function(range, day = 31, format = 'Y-M-d') {
      let _in = true; //是否在时间范围内
      if (range) {
        let start_time = new Date(range[0]).getTime();
        let end_time = new Date(range[1]).getTime();
        let day_time = day * 24 * 60 * 60 * 1000;
        if (end_time - start_time > day_time) {
          _in = false;
          range[0] = new Date(end_time - day_time).format(format);
        }
      }
      return {
        range,
        _in
      }
    }

    /**
     * 商品去重 根据spec_id+'-'+price判断是否重复 由于两个订单合并 同规格商品价格可能不一样
     */
    Vue.prototype.distinctGoods = function(list) {
      if (list instanceof Array) {
        let map = new Map();
        let result = [];
        list.forEach(item => {
          let key = item.spec_id + '-' + item.price + '-' + item.is_replenishment; // 规格id+单价+补货012
          if (map.has(key)) {
            let ind = map.get(key);
            let itm = result[ind];
            // toFixed(6) 防止计算机加法出现多位小数点 0.1+0.2!=0.3
            itm.num_unit = +(Number(itm.num_unit) + Number(item.num_unit)).toFixed(6);
            itm.num = +(Number(itm.num) + Number(item.num)).toFixed(6);
            itm.out_num = +(Number(itm.out_num) + Number(item.out_num)).toFixed(6);
            itm.money = +(Number(itm.money) + Number(item.money)).toFixed(6);
            itm.money_print = +(Number(itm.money_print) + Number(item.money_print)).toFixed(6);
            itm.remark += (item.remark ? `(${item.remark})` : '');
          } else {
            map.set(key, result.length)
            result.push(item);
          }
        })
        return result
      }
      return list
    }

    Vue.prototype.$checkTyps = function() {
      let list = [{
        name: '采购入库',
        id: '1',
      }, {
        name: '退货入库',
        id: '2',
      }, {
        name: '冲账入库',
        id: '3',
      }, {
        name: '调拨入库',
        id: '22',
      }, {
        name: '其他入库',
        id: '4',
      }]
      list.forEach(item => {
        item.name = this.$ts(item.name);
      })
      return list
    }

    Vue.prototype.getUuid = function() {
      var s = [];
      var hexDigits = "0123456789abcdef";
      for (var i = 0; i < 36; i++) {
        s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
      }
      s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
      s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
      s[8] = s[13] = s[18] = s[23] = "-";

      var uuid = s.join("");
      return uuid;
    }

    /**
     * 计算客户商品价格  协议价 星级阶梯价 星级指定价
     * @param {object} spec 商品规格 price_flag==0非协议价 sell商品售价 ladder
     * @param {object} user 用户信息 需要discount折扣 star星级
     * @param {string} sellName 需要更改的售价值
     */
    Vue.prototype.initSpecSell = function(spec, user, sellName = 'sell') {
      spec.price_roles = []; //星级指定价格
      spec.ladders = []; //星级阶梯价
      if (spec.price_flag === 0) {
        // 非 协议价时
        !spec.o_sell && (spec.o_sell = spec.sell)
        spec[sellName] = +(spec.o_sell * (user.discount || 100) / 100).toFixed(2); // 折扣价格;
        if (spec.ladder && spec.ladder.length) {
          //星级阶梯价 跟购买数量相关 购买数量num>itm.ladder时 售价sell = +(+spec.cost+ +itm.gross).toFixed(2)
          spec.ladders = spec.ladder.filter(itm => itm.star == user.star || itm.star == 0);
        }
        if (spec.price_role && spec.price_role.length) {
          //星级指定价
          spec.price_roles = spec.price_role.filter(itm => itm.star == user.star);
          if (spec.price_roles[0]) {
            spec[sellName] = +spec.price_roles[0].sell;
            spec.ladders = [];
          }
        }
      } else {
        spec[sellName] = +spec.price;
      }
      if (spec.price_flag !== 3 && spec.cate_discount > 0 && spec.cate_discount != 100) {
        spec[sellName] = (spec[sellName] * spec.cate_discount / 100).toFixed(2)
      }
      return spec
    }
    /**
     * 选中规格时 计算客户商品星级阶梯价格
     * @param {object} spec 选中规格
     * @param {object} data 商品信息 num购买数量(基础量) sell商品售价
     */
    Vue.prototype.initSpecLadder = function(spec, data) {
      // 客户商品 规格没有星级价格 且 由星级阶梯价格时
      if (!data.o_sell) {
        data.o_sell = data.sell;
      } else {
        data.sell = data.o_sell;
      }
      for (let i = 0; i < spec.ladders.length; i++) {
        let item = spec.ladders[i];
        let price = +(+spec.cost + +item.gross).toFixed(2);
        if (data.num * spec.num >= item.ladder * 1 && data.sell > price) {
          data.sell = price;
          break;
        }
      }
      return data
    }

    Vue.prototype.companyTypes = ['', '餐饮', '机关', '学校', '公司', '超市', '食堂', '门店', 'TFG', '平台', '公司旗下']; // 公司类型
    Vue.prototype.afterReason = ['采购少量', '运输损耗', '分拣损耗', '自然意外损耗', '临时补单', '人为遗失损耗', '其他']; // 售后原因
    Vue.prototype.payStatus = ['新订单-待生效', '已生效-处理中', '配送中-待收货', '已收货-待结算', '发结算-待到款', '已到款-已结算']; // 支付状态

    /* 数字转周末 */
    Vue.prototype.setWeekStr = ['周一', '周二', '周三', '周四', '周五', '周六', '周日'];
    Vue.prototype.weekArr = ['星期天', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

    /* 中文数字转阿拉伯数字 */
    const zhNumberMap = {
      "零": 0,

      "一": 1,
      "壹": 1,

      "二": 2,
      "贰": 2,
      "两": 2,

      "三": 3,
      "叁": 3,

      "四": 4,
      "肆": 4,

      "五": 5,
      "伍": 5,

      "六": 6,
      "陆": 6,

      "七": 7,
      "柒": 7,

      "八": 8,
      "捌": 8,

      "九": 9,
      "玖": 9,

      "十": 10,
      "拾": 10,

      "百": 100,
      "佰": 100,

      "千": 1000,
      "仟": 1000,

      "万": 10000,
      "十万": 100000,
      "百万": 1000000,
      "千万": 10000000,
      "亿": 100000000
    };
    /* 分割商品名称、数量、单位 */
    Vue.prototype.splitStrNumber = function(str) {
      let arr1 = str.replace(/(\d+\.{0,1}\d*)(\D*)$/, '—$1—$2').split('—');
      if (arr1.length > 1) {
        if (arr1.length == 3) {
          return arr1
        } else {
          return arr1.push('斤')
        }
      }
      let arr = str.split('');
      let result = ['', '', ''];
      let map = zhNumberMap;
      for (let i = 0; i < arr.length; i++) {
        let k = arr[i];
        if (isNaN(map[k]) || i == 0) {
          if (result[1]) {
            result[2] = str.substr(i);
            break
          } else {
            result[0] += k;
          }
        } else {
          result[1] += k;
        }
      }
      if (result[1]) {
        result[1] = Vue.prototype.numberDigit(result[1]);
      }
      return result
    }

    // 解析失败返回-1，成功返回转换后的数字，不支持负数
    Vue.prototype.numberDigit = function(chinese_number) {
      let map = zhNumberMap;
      let len = chinese_number.length;
      if (len == 0) return -1;
      if (len == 1) return (map[chinese_number] <= 10) ? map[chinese_number] : -1;
      let summary = 0;
      if (map[chinese_number[0]] == 10) {
        chinese_number = "一" + chinese_number;
        len++;
      }
      if (len >= 3 && map[chinese_number[len - 1]] < 10) {
        let last_second_num = map[chinese_number[len - 2]];
        if (last_second_num == 100 || last_second_num == 1000 || last_second_num == 10000 || last_second_num ==
          100000000) {
          for (let key in map) {
            if (map[key] == last_second_num / 10) {
              chinese_number += key;
              len += key.length;
              break;
            }
          }
        }
      }
      if (chinese_number.match(/亿/g) && chinese_number.match(/亿/g).length > 1) return -1;
      let splited = chinese_number.split("亿");
      if (splited.length == 2) {
        let rest = splited[1] == "" ? 0 : Vue.prototype.numberDigit(splited[1]);
        return summary + Vue.prototype.numberDigit(splited[0]) * 100000000 + rest;
      }
      splited = chinese_number.split("万");
      if (splited.length == 2) {
        let rest = splited[1] == "" ? 0 : Vue.prototype.numberDigit(splited[1]);
        return summary + Vue.prototype.numberDigit(splited[0]) * 10000 + rest;
      }
      let i = 0;
      while (i < len) {
        let first_char_num = map[chinese_number[i]];
        let second_char_num = map[chinese_number[i + 1]];
        if (second_char_num > 9)
          summary += first_char_num * second_char_num;
        i++;
        if (i == len)
          summary += first_char_num <= 9 ? first_char_num : 0;
      }
      return summary;
    }

    //将图片64转本地地址
    Vue.prototype.getBase64Url = function(base64) {
      return new Promise(function(resolve, reject) {
        var arr = base64.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return resolve((window.URL || window.webkitURL).createObjectURL(new Blob([u8arr], {
          type: mime || 'png'
        })));
      });
    }

    //平铺树状数据
    Vue.prototype.tiledList = function(list, arr = [], children = 'children') {
      list.forEach(item => {
        arr.push(item)
        if (item[children] && item[children].length) {
          Vue.prototype.tiledList(item[children], arr, children)
        }
      })
      return arr
    }
    //树状数据提取父级id集合
    Vue.prototype.getPids = function(id, list, key = 'id', keyPid = 'pid', arr = []) {
      let pItem = list.find(item => item[key] == id);
      arr.unshift(id)
      if (pItem && pItem[keyPid]) {
        Vue.prototype.getPids(pItem[keyPid], list, key, keyPid, arr)
      }
      return arr
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/plugins.js